<template>
  <button
    type="button"
    class="group text-left px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 disabled:text-gray-400"
    role="menuitem"
    :disabled="isInSync"
    @click="sync"
  >
    <p>{{ woocommerceApiService.config.name }}</p>
    <p class="text-xs text-gray-600">
      <template v-if="isInSync"> Syncing... </template>
      <template v-else> last synced: {{ lastSyncedAt }} </template>
    </p>
  </button>
</template>

<script>
import moment from 'moment';
import { woocommerceApiServicesClient } from '@/api/clients';

const IDLE = 'IDLE';
const LOADING = 'LOADING';
const RESOLVED = 'RESOLVED';
const REJECTED = 'REJECTED';

export default {
  props: {
    woocommerceApiService: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      status: IDLE,
      rejectReason: '',
    };
  },
  computed: {
    isInSync() {
      return typeof this.woocommerceApiService.config.syncStartedAt === 'string';
    },
    lastSyncedAt() {
      if (typeof this.woocommerceApiService.config.syncLastCompletedAt === 'string') {
        return moment(this.woocommerceApiService.config.syncLastCompletedAt).fromNow();
      }

      return 'never';
    },
  },
  methods: {
    setStatus(status) {
      this.status = status;
    },
    async sync() {
      try {
        this.setStatus(LOADING);
        await this.$store.dispatch('ui/thirdPartyServices/updateFromService', {
          id: this.woocommerceApiService.id,
          formData: {},
          service: woocommerceApiServicesClient.sync,
        });
        this.setStatus(RESOLVED);
      } catch (error) {
        this.rejectReason = error?.response?.message || 'Failed loading.';
        this.setStatus(REJECTED);
      }
    },
  },
};
</script>
